<h3 class="mb-0">{{"compare_measurements.title" | translate}}</h3>
<p class="mb-4">{{"compare_measurements.subtitle" | translate}}</p>

<p-divider></p-divider>

<p-tree
  [value]="treeNodes"
  selectionMode="checkbox"
  [(selection)]="selectedNodes"
  styleClass="w-full border-none mb-4"
/>

<form [formGroup]="compareForm" class="w-full">
  <formly-form [form]="compareForm" [fields]="formFields" [model]="model"></formly-form>
</form>

<div class="w-full flex justify-center my-3">
  <button pButton color="primary" type="submit" class="w-full" [disabled]="!compareForm.valid || !selectedNodes.length" (click)="submit()">{{ 'compare_measurements.button' | translate}}</button>
</div>


@if (loadingChart()) {
  <div class="w-full flex justify-center my-3">
    <i class="fa-solid fa-spinner fa-spin text-2xl"></i>
  </div>
}

@if (!loadingChart() && measurementsToCompare().length && variable()) {
  <p-card appearance="outlined" class="my-2">
    <ng-template #title>{{ "compare_measurements.chart.title" | translate }}</ng-template>
    <ng-template #subtitle>{{ "compare_measurements.chart.subtitle" | translate }}</ng-template>
    <cosmos-multi-line-chart
      [dataObjects]="measurementsToCompare()"
      [dataset]="variable()!"
      [chartId]="'monitoring_compare'"
      [reorder]="true"
      [downloadAllowed]="true"
      [sameOriginAllowed]="true">
    </cosmos-multi-line-chart>
  </p-card>
}
